// RWD table

var fn_responsive_table = function () {

// Wrapping in a DIV all tables
    var $myContext = $('.main');
    $myContext.find('table').each(function () {
        $(this).wrap('<div class="table-responsive"></div>');
    })

};
